module.exports = __webpack_public_path__ + "web/img/type-1.b2c7adc5.png";